import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Subject } from "rxjs";
import {
  Validators,
  UntypedFormGroup,
  UntypedFormControl,
} from "@angular/forms";
import { TechnologyoverlayService } from "../../technologyoverlay.service";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";
import {
  SessionCheck,
  generateAlertMessage,
  AuthFailedMessage,
  LoadTechnologySpaceSvg,
  map_widthandheight,
  getFeatureNeedtoShow,
} from "../../../../app-general";
import {
  mapTemplate_creation,
  get_geojsonObject_floor,
  fillcolor_style,
} from "../../../../map-general";
import {
  appsettings,
  NewDeviceTypeDesc,
  DeviceTypeDesc,
  DeviceType,
  enumRequestFrom,
  fillcolorPolygon,
  enumUIFeatureView,
  enumUIAction,
  enumUIView,enumEnableDisable
} from "../../../../app-settings";
import { GeneralMessageComponent } from "../../../../general-message/general-message.component";
import {
  TechnologyForCreationResponse,
  getTemplateInfo,
  loadTemplateDevice,
  deleteTemplate,
  deletTemplateDevice,
  updateTemplate,
} from "../../technologyoverlay";
import { ConfirmMessageComponent } from "../../../../confirm-message/confirm-message.component";
import { EditSpacedeviceComponent } from "../edit-spacedevice/edit-spacedevice.component";
import { Fill, Stroke, Style, Text } from "ol/style";
import { Observable } from "rxjs";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: "app-edit-spacestemplate",
  templateUrl: "./edit-spacestemplate.component.html",
  styleUrls: ["./edit-spacestemplate.component.scss"],
})
export class EditSpacestemplateComponent implements OnInit {
  bAddEdit = false;
  bDelete = false;
  public uniteditTemplateForm: UntypedFormGroup;
  selectedTempId;
  FloorInfo;
  private _onDestroy: Subject<void> = new Subject<void>();
  Space_Info;
  public watcher: Observable<boolean>;
  columns = 3;
  firstcolumns = 2;
  minheight = "350px";
  rowHeight = "79px";
  checkfloorinfo = false;
  select_SpaceIds = [];
  Campusdetails;
  Buildingdetails;
  selectedCampusId;
  selectedBuildingId;
  selectTemplateName;
  DeviceInfo = [] as any[];
  SpaceImgUrl;
  TempFloordata;
  deletespacedevicedialogopen = 0;
  SpaceTempCount;
  SpaceImagename = "";

  selectTemplateId;
  SpaceTempImgUrl: string = appsettings.TEMPLATE_IMAGE_FOLDER;
  Map_image_path = "assets/images/";
  authkey;
  Breakpoints = Breakpoints;
  readonly breakpoint$ = this.breakpointObserver
    .observe([
      Breakpoints.Large,
      Breakpoints.Medium,
      Breakpoints.Small,
      "(min-width: 500px)",
    ])
    .pipe(
      tap(value => console.log(value)),
      distinctUntilChanged()
    );
  constructor(
    private router: Router,    
    public thisDialogRef: MatDialogRef<EditSpacestemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private technologyoverlayService: TechnologyoverlayService,
    public dialog: MatDialog,    
    private breakpointObserver: BreakpointObserver  
  ) {
    this.selectedTempId = data.TemplateId;
    this.TempFloordata = data;
    this.selectTemplateName = data.TemplateName + "-" + data.Description;
    this.selectTemplateId = "mapEditTemplate_" + data.TemplateId;
    this.Space_Info = data;
    this.SpaceImgUrl = appsettings.TEMPLATE_IMAGE_FOLDER + data.FloorPlanImage;
    this.SpaceTempCount = data.UnitCnt;
    this.SpaceImagename = data.FloorPlanImage;

    setTimeout(() => {
      this.DrawMapCall(this, data);
    }, 1 * 500);
    this.breakpoint$.subscribe(() => this.breakpointChanged());       
  }
  
  breakpointChanged() {    
    if(this.breakpointObserver.isMatched(Breakpoints.Large)) {
      this.columns = 4;
      this.firstcolumns = 2;
      this.minheight = "350px";
    }    
    else if(this.breakpointObserver.isMatched(Breakpoints.Medium)) {
      this.columns = 2;
      this.firstcolumns = 1;
      this.minheight = "350px";
    }     
    else if(this.breakpointObserver.isMatched(Breakpoints.Small)) {
      this.columns = 2;
      this.firstcolumns = 2;
      this.minheight = "auto";
    }
    else if(this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      this.columns = 2;
      this.firstcolumns = 1;
      this.minheight = "auto";
    }
  }

  ngOnInit() {
    this.authkey = localStorage.getItem("Authkey") ?? "";
    this.uniteditTemplateForm = new UntypedFormGroup({
      tempname: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(65),
        Validators.pattern(appsettings.Name_Pattern),
      ]),
      tempID: new UntypedFormControl(""),
    });
    if (
      getFeatureNeedtoShow(
        enumUIFeatureView.Technology,
        enumUIAction.Templates_AddEditDelete
      ) == enumUIView.Show
    ) {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    // this.uniteditTemplateForm.get('tempname').disable();
    this.loadTemplatesForDevice();
  }

  loadTemplatesForDevice() {
    try {
      const voiceLicense = localStorage.getItem("voice_license") ?? "";
      const loadTempDevice: loadTemplateDevice = {
        authKey: this.authkey,
        templateId: parseInt(this.selectedTempId),
        templateCategory: 2,
        isNeedIntercom: parseInt(voiceLicense)
      };
      this.technologyoverlayService
        .loadTemplatesForDevice(loadTempDevice)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((deviceinfo: any[]) => {
          deviceinfo.forEach(function (e) {
            if (e.DeviceName == DeviceTypeDesc.Emitter) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Emitter;
              e["DeviceType"] = DeviceType.Emitter;
            } else if (e.DeviceName == DeviceTypeDesc.HRex) {
              e["NewDeviceName"] = NewDeviceTypeDesc.HRex;
              e["DeviceType"] = DeviceType.HRex;
            } else if (e.DeviceName == DeviceTypeDesc.Rex) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Rex;
              e["DeviceType"] = DeviceType.Rex;
            } 
            else if (e.DeviceName == DeviceTypeDesc.LF) {
              if (e.SubType==DeviceType.DripTray)
              {
                e['NewDeviceName'] = NewDeviceTypeDesc.DripTray;
              }
              else
              {
                e['NewDeviceName'] = NewDeviceTypeDesc.LFExiter;
              }
              e['DeviceType'] = DeviceType.LF;
            }
            else if (e.DeviceName == DeviceTypeDesc.Pullcord) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Pullcord;
              e["DeviceType"] = DeviceType.Pullcord;
            } else if (
              e.DeviceName == DeviceTypeDesc.DC ||
              e.DeviceName == DeviceTypeDesc.NewDC
            ) {
              e["NewDeviceName"] = NewDeviceTypeDesc.DC;
              e["DeviceType"] = DeviceType.DC;
            } else if (e.DeviceName == DeviceTypeDesc.Monitor) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Monitor;
              e["DeviceType"] = DeviceType.Monitor;
            } else if (e.DeviceName == DeviceTypeDesc.VW) {
              e["NewDeviceName"] = NewDeviceTypeDesc.VW;
              e["DeviceType"] = DeviceType.VW;
            } else if (e.DeviceName == DeviceTypeDesc.Gateway) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Gateway;
              e["DeviceType"] = DeviceType.Gateway;
            } else if (e.DeviceName == DeviceTypeDesc.UT) {
              e["NewDeviceName"] = NewDeviceTypeDesc.UT;
              e["DeviceType"] = DeviceType.UT;
            } else if (e.DeviceName == DeviceTypeDesc.UM) {
              e["NewDeviceName"] = NewDeviceTypeDesc.UM;
              e["DeviceType"] = DeviceType.UM;
            } else if (e.DeviceName == DeviceTypeDesc.Intercom) {
              e["NewDeviceName"] = NewDeviceTypeDesc.Intercom;
              e["DeviceType"] = DeviceType.IC;
            } else if (e.DeviceTypeId == DeviceType.Room) {
              e["NewDeviceName"] = "Room";
              e["DeviceType"] = DeviceType.Room;
            } else {
              e["NewDeviceName"] = NewDeviceTypeDesc.Zone;
              e["DeviceType"] = DeviceType.Zone;
            }
          });
          if (deviceinfo.length == 1 && deviceinfo[0].TemplateId == null) {
            this.DeviceInfo = [];
          } else {
            this.DeviceInfo = deviceinfo;
          }
        });
    } catch (err) {
      throw new Error(
        "edit-spacestemplate.component.ts" +
          " - loadTemplatesForDevice() - " +
          err.message
      );
    }
  }

  getTemplatesInfo() {
    try {
      const voiceLicense = localStorage.getItem("voice_license") ?? "0";
      const buildbyid: getTemplateInfo = {
        authKey: this.authkey,
        templateId: parseInt(this.selectedTempId),
        templateCategory: 2,
        isNeedIntercom:parseInt(voiceLicense) 
        
      };
      this.technologyoverlayService
        .getTemplatesInfo(buildbyid)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((templatesinfo: any[]) => {
          const Templates = templatesinfo["Templateinfo"][0];
          this.DrawMapCall(this, Templates);
        });
    } catch (err) {
      throw new Error(
        "edit-spacestemplate.component.ts" +
          " - getTemplatesInfo() - " +
          err.message
      );
    }
  }

  public onCloseCancel = () => {
    this.thisDialogRef.close("Cancel");
    if (!SessionCheck(this.router)) {
      return;
    }
  };

  edit_Spacedetails(devicedata) {
    let width = "37em";
    let height = "580px";

    const tempdeviceData = {
      DeviceData: devicedata,
      TemplateId: this.selectedTempId,
    };
    if (devicedata.DeviceName == "UT") {
      width = "87rem";
      height = "740px";
    }

    const dialogRef = this.dialog.open(EditSpacedeviceComponent, {
      disableClose: true,
      width: width,
      height: height,
      panelClass: "myapp-no-padding-dialog",
      autoFocus: false,
      data: tempdeviceData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "flooreditclose") this.loadTemplatesForDevice();
      this.getTemplatesInfo();
    });
  }

  deleteSpaceDevicedetails(Devicedata) {
    try {      
      const ConfirmMessageData = {
        ConfirmMessage:
          "Are you sure you want to delete " + Devicedata.NewDeviceName + "?",
      };

      if (this.deletespacedevicedialogopen == 0) {
        const dialogRef = this.dialog.open(ConfirmMessageComponent, {
          disableClose: true,
          width: "auto",
          height: "200px",
          panelClass: "myapp-no-padding-dialog",
          autoFocus: false,
          data: ConfirmMessageData,
        });
        this.deletespacedevicedialogopen = 1;
        dialogRef.afterClosed().subscribe((result) => {
          this.deletespacedevicedialogopen = 0;
          if (result == "Yes") {
            this.deleteTemplateDeviceId(Devicedata);
          } else {
            dialogRef.close("Cancel");
            return;
          }
        });
      }
    } catch (err) {
      throw new Error(
        "edit-spacestemplates.component.ts" +
          " - confirmation() - " +
          err.message
      );
    }
  }

  deleteTemplateDeviceId(Data) {
    try {
      const deviceDetails: deletTemplateDevice = {
        authKey: this.authkey,
        templateId: parseInt(Data.TemplateId),
        dataId: parseInt(Data.DataId),
        deviceType:parseInt(Data.DeviceType)
      };
      this.technologyoverlayService
        .deleteTemplateDeviceId(deviceDetails)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse: TechnologyForCreationResponse[]) => {
          if (apiresponse.toString() == "true") {
            generateAlertMessage(
              this.dialog,
              "Device details deleted successfully."
            );
            this.loadTemplatesForDevice();
          } else if (apiresponse.toString() == "false") {
            generateAlertMessage(this.dialog, "Device details deleted failed.");
          }
        });
    } catch (err) {
      throw new Error(
        "edit-templates.component.ts" +
          " - deleteTemplateDeviceId() - " +
          err.message
      );
    }
  }

  clkdltSpaceconfirmdialog(spacedata) {
    const GeneralMessageData = {
      General_header: "Delete Template ",
      GeneralMessage:
        "Would you like to delete all Spaces that<br>use this template as a foundation?</b>",
      General_first: "Yes ",
      General_second: "No",
    };
    const dialogRef = this.dialog.open(GeneralMessageComponent, {
      disableClose: true,
      width: "auto",
      height: "220px",
      panelClass: "myapp-no-padding-dialog",
      autoFocus: false,
      data: GeneralMessageData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "First") {
        this.deleteTemplate(spacedata);
      } else {
        dialogRef.close("Cancel");
        return;
      }
    });
  }

  deleteTemplate(spaceData) {
    try {
      const deletetempfloorbyid: deleteTemplate = {
        authKey: this.authkey,
        templateId: parseInt(spaceData.TemplateId),
        templateCategoryId: parseInt(spaceData.TemplateCategoryId),
      };
      this.technologyoverlayService
        .deleteTemplate(deletetempfloorbyid)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse: TechnologyForCreationResponse[]) => {
          if (apiresponse.toString() == "true") {
            generateAlertMessage(
              this.dialog,
              "Space Template deleted successfully."
            );
          } else if (apiresponse.toString() == "false") {
            generateAlertMessage(this.dialog, "Space Template deleted failed.");
          } else if (apiresponse["condition"] == "Authfalse") {
            this.thisDialogRef.close("close");
            AuthFailedMessage(this.dialog, this.router);
            return;
          }
          this.thisDialogRef.close("Delete");
        });
    } catch (err) {
      throw new Error(
        "edit-spacestemplate.component.ts" +
          " - deleteTemplate() - " +
          err.message
      );
    }
  }

  public updateTemplateInfo = (spacetempFormValue) => {
    try {
      let TempDescriName;
      let TempName = " ";
      let TempDescription = " ";

      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close("Cancel");
        return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      this.editSpaceTemplateEnableDisable(enumEnableDisable.Disable);
      if (this.uniteditTemplateForm.valid) {
        if (spacetempFormValue.tempname.indexOf("-") == -1) {
          if (spacetempFormValue.tempname.length > 32) {
            generateAlertMessage(
              this.dialog,
              "Space Template Name Max length 32 characters only"
            );
            this.editSpaceTemplateEnableDisable(enumEnableDisable.Enable);
            return false;
          } else {
            TempName = spacetempFormValue.tempname.replace(/\s+/g, " ").trim();
            TempDescription = " ";
          }
        } else {
          TempDescriName = spacetempFormValue.tempname
            .replace(/\s+/g, " ")
            .trim();
          TempDescriName = TempDescriName.split("-");
          TempName = TempDescriName[0];
          TempDescription = TempDescriName[1];
        }

        const editspacetempdetails: updateTemplate = {
          authKey: this.authkey,
          templateId: parseInt(spacetempFormValue.tempID),
          templateName: TempName,
          description: TempDescription,
          templateCategoryId: 2,
        };
        this.technologyoverlayService
          .updateTemplateInfo(editspacetempdetails)
          .pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse: any[]) => {
            if (apiresponse.toString() == "true") {
              generateAlertMessage(
                this.dialog,
                "Space Template edited successfully."
              );
              this.thisDialogRef.close("Delete");
            } else if (apiresponse.toString() == "false") {
              generateAlertMessage(
                this.dialog,
                "Space Template edited failed."
              );
              this.thisDialogRef.close();
            } else if (apiresponse["condition"] == "Authfalse") {
              this.thisDialogRef.close("close");
              AuthFailedMessage(this.dialog, this.router);
              return;
            } else if (apiresponse["condition"] == "tempName") {
              generateAlertMessage(
                this.dialog,
                "Space Template name '" + TempName + "' already exists."
              );
              this.editSpaceTemplateEnableDisable(enumEnableDisable.Enable);
              return;
            }
          });
      } else {
        this.editSpaceTemplateEnableDisable(enumEnableDisable.Enable);
      }
    } catch (err) {
      throw new Error(
        "edit-templates.component.ts" +
          " - updateTemplateInfo() - " +
          err.message
      );
    }
  };

  DrawMapCall(_this, Templates) {
    const imgwh = map_widthandheight(Templates.ImageWidth, Templates.ImageHeight);
    const imgwidth = imgwh.ImageWidth;
    const imgheight = imgwh.ImageHeight;

    
    
    

    const devicelabelStyle = new Style({
      text: new Text({
        font: "10px Poppins, sans-serif",
        overflow: true,
        fill: new Fill({
          color: "#000",
        }),
        stroke: new Stroke({
          color: "#fff",
          width: 5,
        }),
        offsetX: 0,
        offsetY: 25.5,
      }),
    });

    const deviceStyle = fillcolor_style(fillcolorPolygon.Completed);

    const fillStyle = [deviceStyle, devicelabelStyle];

    const map = mapTemplate_creation(
      _this.SpaceTempImgUrl + Templates.FloorPlanImage,
      imgwidth,
      imgheight,
      "mapEditTemplate_" + Templates.TemplateId,
      4
    );

    //////////Floor Devices Start////////////

    const arrdevicemarker = [];
    const arrdevicemarkernoPoly = [];
    const SpaceInfo = Templates.SpaceDetail;

    if (SpaceInfo != null) {
      /// Geo Feature Collection ///
      const geoFloorjsonObject = get_geojsonObject_floor(
        enumRequestFrom.floorplan_page
      );
      geoFloorjsonObject.type = "FeatureCollection";

     
      geoFloorjsonObject.features.length = 0;

      /// marker array ///
     
      if (SpaceInfo.length > 0) {
        const arrSpaceInfo = SpaceInfo;
        LoadTechnologySpaceSvg(
          map,
          arrSpaceInfo,
          imgheight,
          imgwidth,
          arrdevicemarker,
          geoFloorjsonObject,
          arrdevicemarkernoPoly,
          devicelabelStyle,
          fillStyle,
          _this.Map_image_path,
          Templates.TemplateId
        );
        _this.editimageheight = imgheight;
        _this.editimagewidth = imgwidth;
      } else if (_this.FloorImageURL == null) {
        const _map = document.getElementById("map");
        if (_map != null)
          _map.innerHTML =
            "<span style='margin-top: 15%; padding-left: 45%;display:block;font-size:15px;font-weight:bold;'> Map Not Found.</span>";
      }
    }

    //////////Floor Devices End////////////
  }

  editSpaceTemplateEnableDisable(checkflag) {
    const elementcontent = document.getElementById("btnspacetempsaveclick");
    if (elementcontent != null && checkflag == enumEnableDisable.Enable)
      elementcontent.className = "clseditUnitTempsavebutton mat-raised-button";
    else if (elementcontent != null && checkflag == enumEnableDisable.Disable)
      elementcontent.className =
        "clseditUnitTempsavebutton mat-raised-button disablebtn";
  }
}
